import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/videoData';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{t('site_name')}</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {t('hero_subtitle')}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('categories')}</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('about')}</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('brand_intro')}</Link></li>
              <li><Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('reputation')}</Link></li>
              <li><Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('contact_us')}</Link></li>
              <li><Link to="/" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('faq_title')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('contact_us')}</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-phone-line text-sm"></i>
                <span>{t('contact_phone')}</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-mail-line text-sm"></i>
                <span>{t('contact_email')}</span>
              </li>
              <li className="flex items-start gap-2 text-foreground-400 text-sm">
                <i className="ri-map-pin-line text-sm mt-0.5"></i>
                <span>{t('contact_address')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">{t('copyright')} | {t('beian')}</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}